import * as Yup from "yup";

import forms from "./forms";

const {
  formField: { observacao },
} = forms;

const validationCortesia = Yup.object().shape({
  [observacao.name]: Yup.string()
    .required(observacao.errorMsg)
    .min(20, observacao.invalidMsg),
});

export { validationCortesia };
